// eslint-disable-next-line no-restricted-properties
export const generateId = () => Math.round(Math.random() * Math.pow(10, 16));



// WEBPACK FOOTER //
// ./src/helpers/misc.helpers.js